import { useMutation } from "react-apollo"

import { queryOptions } from "utils/helper"

import START_ELIGIBILITY_IMPORT from "../graphql/EligibilityFile/mutations/startEligibilityImport"

const useStartEligibilityImportMutation = ({ user = {}, variables, onCompleted }) => {
  return useMutation(START_ELIGIBILITY_IMPORT, {
    ...queryOptions(user, true),
    variables,
    onCompleted,
  })
}

export default useStartEligibilityImportMutation
